// RefundPolicy.jsx
import React from "react";
import "./RefundPolicy.css"; // optional: for additional custom styles

const RefundPolicy = () => {
  return (
    <div className="refund-policy-wrapper">
      <div className="refund-policy-container">
        {/* Header */}
        <div className="policy-header">
          <h1>
            <i className="fas fa-undo-alt" style={{ marginRight: "0.5rem", color: "#d4a373" }}></i>
            Refund Policy
          </h1>
          <p className="effective-date">Effective Date: 30 March 2026</p>
          <p className="intro-text">
            At Maamaa's, we strive to provide our customers with a seamless ordering experience
            and quality service. This Refund Policy explains the circumstances under which
            refunds may be issued for orders placed through our website or mobile application.
          </p>
        </div>

        {/* Policy Sections */}
        <div className="policy-sections">
          {/* 1. Order Cancellation */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-times-circle" style={{ marginRight: "0.6rem", color: "#bc6c25" }}></i>
              1. Order Cancellation
            </h2>
            <ul>
              <li>
                <i className="fas fa-check-circle" style={{ color: "#2a9d8f", marginRight: "0.5rem" }}></i>
                Customers may cancel an order <strong>only before</strong> the restaurant has started preparing the food.
              </li>
              <li>
                <i className="fas fa-exclamation-circle" style={{ color: "#e76f51", marginRight: "0.5rem" }}></i>
                Once the restaurant has accepted the order and preparation has begun, the order <strong>cannot be cancelled</strong>.
              </li>
            </ul>
          </section>

          {/* 2. Refund Eligibility */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-check-double" style={{ marginRight: "0.6rem", color: "#2a9d8f" }}></i>
              2. Refund Eligibility
            </h2>
            <p className="subhead">A refund may be provided in the following situations:</p>
            <ul className="eligibility-list">
              <li><i className="fas fa-credit-card" style={{ marginRight: "0.6rem", color: "#287271" }}></i> The payment was successfully debited, but the order was not placed due to a technical issue.</li>
              <li><i className="fas fa-copy" style={{ marginRight: "0.6rem", color: "#287271" }}></i> A duplicate payment was made for the same order.</li>
              <li><i className="fas fa-utensils" style={{ marginRight: "0.6rem", color: "#287271" }}></i> The restaurant is unable to fulfill the order due to unavailability of items or operational reasons.</li>
              <li><i className="fas fa-store-alt" style={{ marginRight: "0.6rem", color: "#287271" }}></i> The order was cancelled by the restaurant.</li>
              <li><i className="fas fa-box-open" style={{ marginRight: "0.6rem", color: "#287271" }}></i> The customer received an incorrect order or significant items were missing.</li>
              <li><i className="fas fa-truck" style={{ marginRight: "0.6rem", color: "#287271" }}></i> The order was not delivered due to reasons attributable to Maamaa's or the restaurant partner.</li>
            </ul>
            <p className="note">
              <i className="fas fa-shield-alt" style={{ marginRight: "0.4rem", color: "#bc6c25" }}></i>
              Refund requests are subject to verification by our support team.
            </p>
          </section>

          {/* 3. Non-Refundable Situations */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-ban" style={{ marginRight: "0.6rem", color: "#d62828" }}></i>
              3. Non-Refundable Situations
            </h2>
            <p className="subhead">Refunds will generally <strong>not</strong> be provided in the following cases:</p>
            <ul className="non-refundable-list">
              <li><i className="fas fa-map-pin" style={{ marginRight: "0.6rem", color: "#d62828" }}></i> Incorrect delivery address provided by the customer.</li>
              <li><i className="fas fa-user-slash" style={{ marginRight: "0.6rem", color: "#d62828" }}></i> Customer was unavailable to receive the order.</li>
              <li><i className="fas fa-clock" style={{ marginRight: "0.6rem", color: "#d62828" }}></i> Order cancellation requested after food preparation has started.</li>
              <li><i className="fas fa-egg" style={{ marginRight: "0.6rem", color: "#d62828" }}></i> Minor differences in taste, presentation, or packaging that do not affect the quality or safety of the food.</li>
              <li><i className="fas fa-cloud-rain" style={{ marginRight: "0.6rem", color: "#d62828" }}></i> Delays caused by unforeseen circumstances such as traffic, weather conditions, or other events beyond our reasonable control.</li>
            </ul>
          </section>

          {/* 4. Refund Process */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-sync-alt" style={{ marginRight: "0.6rem", color: "#2a9d8f" }}></i>
              4. Refund Process
            </h2>
            <p className="subhead">Once a refund request is approved:</p>
            <ul>
              <li>
                <i className="fas fa-credit-card" style={{ marginRight: "0.6rem", color: "#287271" }}></i>
                Refunds will be processed to the <strong>original payment method</strong> used during the transaction.
              </li>
              <li>
                <i className="fas fa-calendar-alt" style={{ marginRight: "0.6rem", color: "#287271" }}></i>
                Refunds are typically completed within <strong>5 to 7 business days</strong>. The actual credit timeline may vary depending on the customer's bank or payment service provider.
              </li>
            </ul>
          </section>

          {/* 5. Failed or Unsuccessful Transactions */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: "0.6rem", color: "#e67e22" }}></i>
              5. Failed or Unsuccessful Transactions
            </h2>
            <p>
              If your payment is debited but the order is not confirmed, the amount will either:
            </p>
            <ul>
              <li><i className="fas fa-arrow-rotate-left" style={{ marginRight: "0.6rem", color: "#287271" }}></i> Be automatically reversed by your bank or payment provider, or</li>
              <li><i className="fas fa-hand-holding-dollar" style={{ marginRight: "0.6rem", color: "#287271" }}></i> Be refunded by Maamaa's after verification.</li>
            </ul>
            <p className="note">
              <i className="fas fa-clock" style={{ marginRight: "0.4rem", color: "#bc6c25" }}></i>
              If the refund is not received within 7 business days, please contact our support team.
            </p>
          </section>

          {/* 6. Contact Us */}
          <section className="policy-card contact-card">
            <h2>
              <i className="fas fa-headset" style={{ marginRight: "0.6rem", color: "#bc6c25" }}></i>
              6. Contact Us
            </h2>
            <p className="subhead">For any questions regarding refunds or payment-related issues, please contact us:</p>
            <div className="contact-details">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@maamaas.com">info@maamaas.com</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone-alt"></i>
                <a href="tel:+919036888450">+91-9036888450</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-globe"></i>
                <a href="https://www.maamaas.com" target="_blank" rel="noopener noreferrer">https://www.maamaas.com</a>
              </div>
            </div>
          </section>
        </div>

        {/* Footer note */}
        <div className="policy-footer">
          <p>
            <i className="fas fa-heart" style={{ color: "#bc6c25", marginRight: "0.3rem" }}></i>
            Maamaa's – made with care
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;